import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostsKey } from '../../utils/keys';
export const usePosts = (options) => {
    const { variables, fields = 'default', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const postsKey = getPostsKey({ variables, fields });
    return useInfiniteQuery(postsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.posts.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=usePosts.js.map